import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { updateTreasuryAccount } from '../treasuryAccountsEndpoints'
import { treasuryAccountKeys } from '../treasuryAccountsQueryKeys'

export function useUpdateTreasuryAccountMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: updateTreasuryAccount,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: treasuryAccountKeys.lists() })
    },
  })
}
